export { CinchCareWarrantyIcon } from "./cinch-care-warranty";
